var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48 488a24 24 0 0 1 0-48 294.062 294.062 0 0 0 209.3-86.7 294.066 294.066 0 0 0 86.7-209.3v-96a24 24 0 0 1 48 0v96a341.876 341.876 0 0 1 -27.043 133.907 342.818 342.818 0 0 1 -73.712 109.337 343 343 0 0 1 -243.245 100.756z",
    fill: "#8690fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m464.017 200a23.96 23.96 0 0 1 -19.218-9.6l-76.799-102.4-76.8 102.4a24 24 0 1 1 -38.4-28.8l96-128a24 24 0 0 1 38.4 0l96 128a24 24 0 0 1 -19.183 38.4z",
    fill: "#5153ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.cf5d405e67f3afa35698a4b6559cb25e.svg";
export { ForwardRef as ReactComponent };